import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Form } from "antd";
import { useFormService, useI18n } from "../../../../../contexts";
import { FormServiceFieldHandlingSkipIfActiveNotice } from ".";
import { FormValueDifferFromTemplateTag } from "../../..";
const FormServiceFieldHandlingCodeOnPageLoad = ()=>{
    const { __ } = useI18n();
    const { renderCodeMirror } = useFormService();
    const [ref, setRef] = useState();
    return /*#__PURE__*/ _jsxs(Form.Item, {
        label: __("Code executed on page load"),
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: "codeOnPageLoad",
                noStyle: true,
                children: renderCodeMirror()
            }),
            /*#__PURE__*/ _jsx(FormServiceFieldHandlingSkipIfActiveNotice, {
                name: "codeOnPageLoad"
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: setRef,
                children: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                    style: {
                        marginTop: 10
                    },
                    form: "service",
                    valueName: "codeOnPageLoad",
                    widthOfRef: ref,
                    noBr: true,
                    splitView: false
                })
            })
        ]
    });
};
export { FormServiceFieldHandlingCodeOnPageLoad };
